// frontend/src/lib/supabase.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || ''
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

// Warn instead of throwing — allows the build to succeed even without env vars.
// The app will show errors at runtime if credentials are missing.
const isConfigured = supabaseUrl && supabaseAnonKey

if (!isConfigured && typeof window !== 'undefined') {
  console.error(
    '🚨 Supabase is not configured.\n' +
    'Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your environment variables.'
  )
}

// Create the Supabase client (uses empty strings if not configured —
// API calls will fail gracefully at runtime rather than crashing the build)
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.placeholder',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      // 'implicit' is required so email verification and password-reset links
      // work when opened in any browser (email client WebView, default browser,
      // etc.).  PKCE stores a code verifier in localStorage — if the link is
      // opened in a different browser from the one that initiated signup the
      // verifier is missing and the token exchange silently fails.
      flowType: 'implicit',
    }
  }
)

// Export configuration for debugging
export const config = {
  url: supabaseUrl,
  isConfigured,
  hasAnonKey: !!supabaseAnonKey,
  keyPreview: supabaseAnonKey ? supabaseAnonKey.substring(0, 20) + '...' : 'Missing'
}

// Development-only logging
if (process.env.NODE_ENV === 'development' && isConfigured) {
  console.log('🔧 Supabase Client Configuration:')
  console.log('   URL:', supabaseUrl)
  console.log('   Key Preview:', config.keyPreview)
  console.log('   Status: ✅ Ready')
}
